import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import numeral from 'numeral';

import { getEnvironmentSettings } from 'services/environment';
import selector from './selector';

import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import FormLabel from '@mui/material/FormLabel';
import Switch from '@mui/material/Switch';
import makeStyles from '@mui/styles/makeStyles';
import { TextField } from 'widgets-v6/standard-input';
import TextFieldFormatter from 'widgets-v6/text-field-formatter';

const useStyles = makeStyles(theme => ({
    red: {
        color: '#FF6584',
    },
    labelContainer: {
        textAlign: 'right',
    },
    subSectionContainer: {
        marginTop: theme.spacing(2),
    },
}));

const segmentsRestructured = [
    {
        label: 'Brand Visitation',
        value: 'pds_brand',
    },
    {
        label: 'Category Visitation',
        value: 'pds_category',
    },
    {
        label: 'Behavioural Visitation',
        value: 'pds_behavioural',
    },
    {
        label: 'Declared Age',
        value: 'pds_declared_age',
    },
    {
        label: 'Interest & Intent',
        value: 'pds_intent',
    },
    {
        label: 'Seasonal',
        value: 'pds_seasonal',
    },
    {
        label: 'Custom Defined',
        value: 'pds_custom_defined',
    },
    {
        label: 'Custom Developed',
        value: 'pds_custom_developed',
    },
    {
        label: 'Retargeting',
        value: 'retargeting',
    },

    {
        label: 'Flex Geolocation',
        value: 'flex_geolocation',
    },
    {
        label: 'Environics',
        value: 'pds_environics',
    },
    {
        label: 'Manifold',
        value: 'pds_manifold',
    },
    {
        label: 'Adobe',
        value: 'adobe',
    },
    {
        label: 'Uploaded',
        value: 'upload',
    },
];

const FeatureSets = ({
    draft,
    onToggleSegment,
    onAudienceRateChange,
    onChange,
    errors,
    showErrors,
}) => {
    const classes = useStyles();
    const envSettings = getEnvironmentSettings();

    const segmentsToUse = segmentsRestructured;

    return (
        <div>
            <Grid container direction="column" spacing={2}>
                {envSettings.canUseAdminFeatureSetsFTA() && (
                    <div>
                        <Typography gutterBottom variant="h6">
                            {' '}
                            Foot Traffic Attribution{' '}
                        </Typography>
                        <Grid item xs={12}>
                            <Grid container direction="row" alignItems="center">
                                <Grid item xs={4}>
                                    <FormLabel required classes={{ asterisk: classes.red }}>
                                        Foot Traffic Attribution
                                    </FormLabel>
                                </Grid>
                                <Grid item xs={5}>
                                    <Switch
                                        color="primary"
                                        checked={draft.ftaEnabled}
                                        onChange={e => onChange('ftaEnabled', e.target.checked)}
                                    />
                                </Grid>
                            </Grid>
                            {draft.ftaEnabled && (
                                <React.Fragment>
                                    <Grid
                                        className={classes.subSectionContainer}
                                        container
                                        direction="row"
                                        alignItems="center"
                                    >
                                        <Grid item xs={4}>
                                            <FormLabel required classes={{ asterisk: classes.red }}>
                                                FTA Partner ID
                                            </FormLabel>
                                        </Grid>
                                        <Grid item xs={5}>
                                            <TextField
                                                required
                                                fullWidth
                                                value={draft.fta_partner_id}
                                                onChange={e =>
                                                    onChange('fta_partner_id', e.target.value)
                                                }
                                                helperText={showErrors && errors.fta_partner_id}
                                                error={showErrors && errors.fta_partner_id}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid container direction="row" alignItems="center">
                                        <Grid item xs={4}>
                                            <FormLabel required classes={{ asterisk: classes.red }}>
                                                FTA Data Cost
                                            </FormLabel>
                                        </Grid>
                                        <Grid item xs={5}>
                                            <TextFieldFormatter
                                                initialValue={draft.fta_fee}
                                                onChange={value => onChange('fta_fee', value)}
                                                shouldAllowChange={v => !/[a-zA-Z]/.test(v)}
                                                formatIn={v => {
                                                    return numeral(v).format('0,0.00');
                                                }}
                                                formatOut={v => {
                                                    return v ? numeral(v).value() : 0;
                                                }}
                                                renderInput={({ value, onChange }) => (
                                                    <TextField
                                                        required
                                                        fullWidth
                                                        value={value}
                                                        onChange={onChange}
                                                        startAdornment={<div>$</div>}
                                                        endAdornment={<div>CPM</div>}
                                                        helperText={showErrors && errors.fta_fee}
                                                        error={showErrors && errors.fta_fee}
                                                    />
                                                )}
                                            />
                                        </Grid>
                                    </Grid>
                                </React.Fragment>
                            )}
                        </Grid>
                    </div>
                )}

                <Grid item xs={12}>
                    <Typography gutterBottom variant="h6">
                        {' '}
                        Audiences{' '}
                    </Typography>
                    <Grid container direction="row" className={classes.subSectionContainer}>
                        <Grid item xs={4}>
                            <Typography> Audience Name </Typography>
                        </Grid>
                        <Grid item xs={4}>
                            <Typography align="center"> Enabled </Typography>
                        </Grid>
                        <Grid item xs={4}>
                            <Typography align="right"> Data Cost </Typography>
                        </Grid>
                    </Grid>
                    {_.map(segmentsToUse, segment => {
                        return !segment.showOn || segment.showOn() ? (
                            <Grid container direction="row" alignItems="center" key={segment.value}>
                                <Grid item xs={4}>
                                    <Typography> {segment.label} </Typography>
                                </Grid>
                                <Grid item xs={4}>
                                    <Grid container justifyContent="center">
                                        <Switch
                                            color="primary"
                                            checked={
                                                !_.includes(draft.restrictedSegments, segment.value)
                                            }
                                            onChange={e =>
                                                onToggleSegment(segment.value, e.target.checked)
                                            }
                                        />
                                    </Grid>
                                </Grid>
                                <Grid item xs={4}>
                                    <TextFieldFormatter
                                        initialValue={_.get(
                                            draft.audienceRatesMap,
                                            `${segment.value}.fee`
                                        )}
                                        onChange={value =>
                                            onAudienceRateChange(segment.value, value)
                                        }
                                        shouldAllowChange={v => !/[a-zA-Z]/.test(v)}
                                        formatIn={v => {
                                            return numeral(v).format('0,0.00');
                                        }}
                                        formatOut={v => {
                                            return v ? numeral(v).value() : 0;
                                        }}
                                        renderInput={({ value, onChange }) => (
                                            <TextField
                                                required
                                                fullWidth
                                                value={value}
                                                onChange={onChange}
                                                startAdornment={<div>$</div>}
                                                endAdornment={<div>CPM</div>}
                                            />
                                        )}
                                    />
                                </Grid>
                            </Grid>
                        ) : null;
                    })}
                </Grid>
            </Grid>
        </div>
    );
};

export default connect(selector)(FeatureSets);
